import Swiper, { Pagination } from 'swiper';
import 'swiper/swiper-bundle.min.css';

export const jobSlider = () => {
    const container = document.querySelector('[js-job-slider]')

    if (container) {
        const breakpoint = window.matchMedia('(min-width: 1024px)');
        let slider;

        const enableSlider = () => {
            slider = new Swiper(container, {
                modules: [ Pagination ],
                speed: 500,
                effect: 'slide',
                slidesPerView: 1.3,
                spaceBetween: 12,
                pagination: {
                    el: '.swiper-pagination',
                    clickable: true,
                },
                breakpoints: {
                    640: {
                        slidesPerView: 2.2,
                        spaceBetween: 24
                    },
                },
            });
        };

        const disableSlider = () => {
            if (slider) {
                slider.destroy(true, true);
                slider = undefined;
            }
        };

        const breakpointChecker = () => {
            if (breakpoint.matches) {
                disableSlider();
            } else {
                enableSlider();
            }
        };

        breakpoint.addEventListener('change', breakpointChecker);
        breakpointChecker();
    }
};
